var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-563tph",
    "aria-label": "rewards",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 17.768L16.0102 19.876C16.7912 20.286 17.7032 19.623 17.5542 18.754L16.7882 14.288L20.0342 11.127C20.6662 10.511 20.3182 9.43801 19.4442 9.31101L14.9602 8.65901L12.9552 4.59401C12.5652 3.80301 11.4362 3.80301 11.0462 4.59401L9.04023 8.65901L4.55623 9.31101C3.68323 9.43801 3.33423 10.511 3.96623 11.127L7.21223 14.288L6.44623 18.754C6.29723 19.623 7.20923 20.287 7.99023 19.876L12.0012 17.768H11.9992Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaricon);
export default __webpack_public_path__ + "static/media/staricon.8ea4c33505dcec3ccb5f192b8b8d115d.svg";
export { ForwardRef as ReactComponent };